import { storyblokEditable } from "@storyblok/react"
import { render } from "storyblok-rich-text-react-renderer"

import { OutlineChevronDown } from "@mkt/ui/icons/Cp/index"

import * as S from "./styles.js"

const Card = ({
  box,
  active,
  onClick,
  header,
  expandY = false,
  borderRadius = 8,
  padding = 16,
  divider = true,
}) => {

  return (
    <div
      {...storyblokEditable(box)}
      css={S.wrapper}
    >
      <div css={S.box(expandY, borderRadius, padding)}>
        <div css={S.header} onClick={onClick}>
          {header}
          <div css={S.arrow(active)}><OutlineChevronDown /></div>
        </div>

        <p css={S.content(active, divider)}>{render(box?.content)}</p>
      </div>
    </div>
  )
}

export default Card
